import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import createLogger from 'src/utils/logger';
import { SUGGESTED_ROLES } from 'src/constants/suggestions';
import { User } from 'src/api';
import { user as userActions } from 'src/actions';
import { SaveBtn, DeleteableInput, AutoSuggestInput } from 'src/components/Common';
import './user-roles.scss';

class UserRoles extends Component {
  constructor() {
    super();
    this.logger = createLogger('UserRoles');
    this.state = {
      inEditMode: false,
      roles: [],
    };
  }

  componentDidMount() {
    this.setState({ roles: this.getPropsUserRoles() });
  }

  toggleEdit = () => {
    this.setState((state) => {
      return {
        roles: this.getPropsUserRoles(),
        inEditMode: !state.inEditMode,
      }
    });
  }

  getRoleSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    return !inputValue.length ? [] : SUGGESTED_ROLES.filter((role) => role.toLowerCase().indexOf(inputValue) !== -1);
  }

  getPropsUserRoles = () => {
    return [...this.props.roles];
  }

  onRoleAdd = (role) => {
    this.logger.info('onRoleAdd()', role);
    return new Promise((res, rej) => {
      if (this.state.roles.indexOf(role) === -1) {
        this.setState({
          roles: [...this.state.roles, role],
        })
        res();
      } else {
        rej('Такая роль уже добавлена.');
      }
    })
  }
 
  onRoleDeletion = (role) => {
    this.logger.info('onRoleDeletion()', role);
    this.setState((state) => {
      const roleIndex = state.roles.indexOf(role);
      if (roleIndex > -1) {
        const roles = [...state.roles];
        roles.splice(roleIndex, 1);
        return { roles };
      }
      return state;
    })
  }

  saveUpdatedRoles = () => {
    this.logger.info('saveUpdatedRoles()', this.state.roles);
    User.updateUser.updateSkillsAndRoles({ roles: this.state.roles, skills: this.props.skills})
      .then((res) => {
        this.props.updateSkillsAndRoles({ skills: res.data.skills, roles: res.data.roles });
        toast.success('Роли успешно обновлены.');
        this.toggleEdit()
      })
      .catch((err) => {
        toast.error('Что-то пошло не так :(');
        this.logger.error('NOT UPDATED ROLES:', err.response);
      });
  }

  render() {
    return (
      <div className={`left-bar__block roles-bar ${this.state.inEditMode ? 'editing' : ''}`}>
        {
          this.state.inEditMode ? (
            <div className="roles-bar--edit">
              <div className="left-bar__title">Роль в команде</div>
              <div className="edit--block">
               {this.state.roles.map((role) => {
                 return (
                   <DeleteableInput key={role} inputName={role} value={role} isEditable={false} onDelete={this.onRoleDeletion} />
                 );
               })}
              </div>
              <div className="edit-block">
                <AutoSuggestInput 
                  getSuggestions={this.getRoleSuggestions}
                  addEntity={this.onRoleAdd} />
              </div>
              <div className="edit-block">
                <SaveBtn saveText="Сохранить" cancelText="Отменить" onSave={this.saveUpdatedRoles} onCancel={this.toggleEdit} />
              </div>
            </div>
          ) : (
            <React.Fragment>
              <div className="left-bar__block-header">
                <div className="left-bar__edit" onClick={this.toggleEdit}>
                  {this.props.editSvg}
                </div>
                <div className="left-bar__title">Роль в команде</div>
              </div>
              <div className="left-bar__block-content">
                {this.props.roles.map((el, i) => <p className='left-bar__text' key={i}>{el}</p>)}
              </div>
            </React.Fragment>
          )
        }
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    roles: state.user.roles,
    skills: state.user.skills,
  }
}
UserRoles.propTypes = {
  roles: PropTypes.array.isRequired,
  skills: PropTypes.array.isRequired,
  updateSkillsAndRoles: PropTypes.func.isRequired,
  editSvg: PropTypes.element.isRequired,
}

export default connect(mapStateToProps, {
  updateSkillsAndRoles: userActions.updateSkillsAndRoles,
})(UserRoles);


// WEBPACK FOOTER //
// ./src/components/Account/LeftBar/UserRoles/index.js